import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { AbstractComponent, Message, MessageService } from 'lib-trend-core'
import { takeUntil } from 'rxjs'

@Component({
    selector: 'webhook-message-view-edit',
    templateUrl: './webhook-message-view.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebhookMessageViewComponent extends AbstractComponent {
  message: Message = undefined
  isLoading = true

  constructor(
    injector: Injector,
    private messageService: MessageService,
    @Inject(MAT_DIALOG_DATA) private messageId: string,
    private dialogRef: MatDialogRef<WebhookMessageViewComponent>,
  ) {
    super(injector)
  }

  ngOnInit() {
    this.messageService
      .getByMessageId(this.messageId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((message) => {
        this.message = message

        this.isLoading = false
      })
  }

  onClose(): void {
    this.dialogRef.close()
  }
}
